<template>
  <aside aria-label="Site menu">
	  <div class="c-sitemenu__menu" @click="open">
			<div class="c-sitemenu__menu-bar c-sitemenu__menu-bar--first"></div>
			<div class="c-sitemenu__menu-bar c-sitemenu__menu-bar--second"></div>
			<div class="c-sitemenu__menu-bar c-sitemenu__menu-bar--last"></div>
		</div>
    <site-menu-overlay
      :is-open="isOpen"
      placement="right"
      @close="close"
      class="c-sitemenu"
    >
      <template v-slot:menu >
		<slot name="menu"></slot>
      </template>
    </site-menu-overlay>
  </aside>
</template>

<script>
import SiteMenuOverlay from "./SiteMenuOverlay.vue";

export default {
  name: "SiteMenu",
  components: {
    SiteMenuOverlay,
  },
  data: () => {
    return {
      isOpen: false,
    };
  },
  methods: {
    close() {
      this.isOpen = false;
    },
    open() {
      this.isOpen = true;
    },
  },
};
</script>

<style lang="scss">
@import "../../scss/abstracts/variables.scss";

.c-sitemenu {
	&__menu{
		cursor: pointer;
		height: 50px;
		width: 80px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		padding: 15px 0px 15px 60px;
		&-bar{
			height: 2px;
			min-height: 2px;
			background-color: #222221;
			margin-bottom: 5px;
			transition: $t-hover;

			&--last{
				width: 60%;
				margin-left: auto;
				transition: $t-hover;
			}
		}

		&:hover{
			.c-sitemenu{
				&__menu{
					&-bar{
						background-color: rgba($color: #000000, $alpha: .5);
						transition: $t-hover;
						&--last{
							transition: $t-hover;
							width: 100%;
						}
					}
				}
			}

		}
	}
}
</style>
